import type { TFunction } from "i18next";
import * as yup from "yup";

import { createDailyHoursFields } from "@/shared/lib/dailyHoursSchema";

import { hasAllowedExtension, MAX_FILE_SIZE_BYTES } from "./erpFile";

export const buildClassroomTemplateSchema = (t: TFunction) =>
    yup.object({
        title: yup.string().max(100).required().default(""),
        description: yup.string().max(300).default(""),
        language: yup.string().required(),
        location: yup.string(),
        factory: yup.string().required(),
        ...createDailyHoursFields({
            required: t("features.classroomCreation.step-2.dailyHours.required"),
            invalid: t("features.classroomCreation.step-2.dailyHours.invalid"),
            endAfterStart: t("features.classroomCreation.step-2.dailyHours.endAfterStart"),
            maxGap: t("features.classroomCreation.step-2.dailyHours.maxGap"),
        }),
        isBadgesEnabled: yup.boolean().default(false),
        image: yup.object({ "@id": yup.string().required() }).nullable().default(null),
        trainingActions: yup
            .array()
            .of(
                yup.object({
                    rank: yup.number().required(),
                    erpIdentifier: yup.string().trim().required(),
                    erpFile: yup
                        .mixed<File>()
                        .nullable()
                        .default(null)
                        .test(
                            "erpFile-extension",
                            t("features.classroomCreation.step-2.erpFile.invalidExtension"),
                            file => !(file instanceof File) || hasAllowedExtension(file),
                        )
                        .test(
                            "erpFile-size",
                            t("features.classroomCreation.step-2.erpFile.tooLarge"),
                            file => !(file instanceof File) || file.size <= MAX_FILE_SIZE_BYTES,
                        ),
                }),
            )
            .default([]),
    });

export const staticSchema = buildClassroomTemplateSchema(((k: string) => k) as TFunction);

export type ClassroomTemplateFormValues = yup.InferType<typeof staticSchema>;
